"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BOX_SHADOW: "\n    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n    transition: box-shadow 0.3s cubic-bezier(.25,.8,.25,1);\n  "
};